import { Reveal } from "./Reveal";
import { ComingSoonCover } from "./ComingSoon";

const QUALIFICATIONS = [
  "AFP® – Financial Planner, Financial Advice Association of Australia.",
  "Diploma of Financial Planning, The Monarch Institute, Australia.",
  "Advanced Diploma of Financial Planning, Kaplan Professional, Australia.",
  "Self-Managed Super Fund (SMSF) Accreditation, The Monarch Institute, Australia.",
  "Ethics and Professionalism in Financial Advice, Kaplan Professional, Australia.",
  "Commercial Law, Kaplan Professional, Australia.",
  "Member of the Financial Advice Association Australia (FAAA).",
  "Qualified Financial Adviser (QFA), University College Dublin, Ireland.",
  "Retirement Planning Adviser (RPA), Life Insurance Association (LIA), Ireland.",
  "Former Member of the Institute of Bankers (IOB), Ireland.",
  "Former Member of the Life Insurance Association (LIA), Ireland.",
  "Bachelor of Arts (Honours Degree) in Financial Services, National College of Ireland.",
];

const CREDENTIALS = [
  { label: "Qualifications, designations and memberships", value: QUALIFICATIONS, wide: true },
];

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-[#F9F8F4] py-16 md:py-36 overflow-hidden">
    <div className="mx-auto max-w-7xl px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-start">
      <div data-testid="about-divider" aria-hidden="true" className="md:col-span-12 flex items-center justify-center gap-6 mb-4 md:mb-8">
        <span className="h-px w-16 md:w-28 bg-[#0A2333]/15" />
        <img src="/assets/nua-mark-transparent.png" alt="" className="h-9 w-auto opacity-90" />
        <span className="h-px w-16 md:w-28 bg-[#0A2333]/15" />
      </div>
      <Reveal className="md:col-span-5">
        <div className="relative">
          <div aria-hidden="true" className="absolute -top-4 -left-4 h-full w-full border border-[#0A2333]/30" />
          <ComingSoonCover testid="about-portrait-cover" label="Coming soon">
            <div className="relative overflow-hidden" data-testid="about-portrait-frame">
              <img
                src="https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBjb25maWRlbnQlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODc5MDk3ODJ8MA&ixlib=rb-4.1.0&q=85"
                alt="Portrait of the founder and principal adviser"
                className="h-[60vh] md:h-[70vh] w-full object-cover"
                data-testid="about-portrait"
              />
            </div>
          </ComingSoonCover>
        </div>
        <p className="mt-6 text-[10px] uppercase tracking-[0.25em] text-[#4A524D]" data-testid="about-portrait-caption">
          Kevin · Founder &amp; Principal Adviser
        </p>
      </Reveal>

      <div className="md:col-span-7 md:pt-8">
        <Reveal>
          <p className="flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-[#0A2333]">
            <span className="h-px w-10 bg-[#0A2333]" aria-hidden="true" />
            About your adviser
          </p>
          <h2 data-testid="about-heading" className="mt-6 font-serif text-3xl md:text-4xl tracking-tight text-[#111413] max-w-lg">
            The only agenda in the room is yours.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 text-base leading-relaxed text-[#4A524D] max-w-xl">
            After nearly 15 years within large institutions, I stepped away to build the kind of
            financial advice practice I could proudly recommend to my own friends and family.
          </p>
          <p className="mt-5 text-base leading-relaxed text-[#4A524D] max-w-xl">
            In this environment, no one upstream has any input in what’s recommended and no hidden
            agendas interfere with your financial well-being. At NUA Private Wealth, only your
            objectives come first.
          </p>
          <p className="mt-5 text-base leading-relaxed text-[#4A524D] max-w-xl">
            My clients are the absolute foundation of my practice. Building deep, trusted
            relationships is why I do this work, and ensuring your needs come first is simply my
            priority.
          </p>
          <p className="mt-5 text-base leading-relaxed text-[#4A524D] max-w-xl">
            I am based in Canberra but work across Sydney, NSW and wider Australia. My
            clients include HNW families, public servants, defence families, business owners,
            accumulators and retirees across the ACT and beyond.
          </p>
          <p className="mt-5 text-base leading-relaxed text-[#4A524D] max-w-xl">
            The NUA approach is
            straightforward: understand what matters to you, explain your options clearly and
            provide advice you can act on with confidence. We map everything out for you to help
            you visualise what might be possible under a range of circumstances.
          </p>
          <div data-testid="about-story" className="mt-10 max-w-xl">
            <h3 className="flex items-center gap-3 font-serif text-xl md:text-2xl tracking-tight text-[#111413]">
              <img src="/assets/nua-mark-transparent.png" alt="" className="-ml-[3.5px] h-9 w-auto shrink-0 opacity-90" data-testid="about-triskelion" />
              The Story Behind NUA
            </h3>
            <p className="mt-4 text-base leading-relaxed text-[#4A524D]">
              I chose the name Nua because it means “new, fresh, modern” in Irish. It's a nod to my
              Irish heritage and to the fresh approach to financial advice I wanted to build. I
              believe advice should evolve with your life, helping you make confident decisions
              today while planning for the future.
            </p>
            <p className="mt-5 text-base leading-relaxed text-[#4A524D]">
              The Triskelion, an ancient symbol of Irish heritage, brings that philosophy to life
              for me. Its three spirals are often interpreted as the past, present and future,
              symbolising movement, progress and continuous growth.
            </p>
            <p className="mt-5 text-base leading-relaxed text-[#4A524D]">
              Together, the name and symbol capture how I work with every client: understanding
              where you've come from, making the most of where you are and building towards where
              you want to be.
            </p>
          </div>

        </Reveal>
        <Reveal delay={0.15}>
          <dl className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-8 border-t border-black/10 pt-10" data-testid="about-credentials">
            {CREDENTIALS.map((c) => (
              <div key={c.label} className={c.wide ? "sm:col-span-2" : ""}>
                <dt className="text-xs md:text-sm uppercase tracking-[0.2em] text-[#A78558]">{c.label}</dt>
                {Array.isArray(c.value) ? (
                  <dd className="mt-3">
                    <ul className="flex flex-col gap-y-2.5" data-testid="about-qualifications">
                      {c.value.map((q) => (
                        <li key={q} className="relative pl-4 text-[13px] md:text-sm leading-relaxed text-[#111413] lg:whitespace-nowrap before:absolute before:left-0 before:top-[0.6em] before:h-1 before:w-1 before:rounded-full before:bg-[#A78558]">
                          {q}
                        </li>
                      ))}
                    </ul>
                  </dd>
                ) : (
                  <dd className="mt-2 text-sm leading-relaxed text-[#111413]">{c.value}</dd>
                )}
              </div>
            ))}
          </dl>
        </Reveal>
      </div>
    </div>
  </section>
);
